import Vue from 'vue'

import breakpoint from '@/globals/breakpoint'
Vue.use(breakpoint)

import modal from '@/globals/modal'
Vue.use(modal)
